import type { Sprite } from '../spriteLayout';

// Single 9-arg drawImage seam for every battle sprite. Atlas sprites share ONE HTMLImageElement
// and carry a source rect (sx,sy,sw,sh); per-file fallback sprites have no rect → the whole
// drawable. NEVER slice the atlas into a canvas — iOS WebKit purges retained canvases (bodies
// vanish, guns float). All draws go through here so that rule holds in one place.

const srcW = (sp: Sprite): number => sp.sw ?? sp.canvas.width;
const srcH = (sp: Sprite): number => sp.sh ?? sp.canvas.height;

/** Draw the FULL sprite (its whole source rect) at (dx,dy), sized (dw,dh) — defaulting to the
 *  sprite's natural pixel size, so this is a drop-in for the old 3-arg `drawImage(sp.canvas,dx,dy)`. */
export function drawSprite(
  ctx: CanvasRenderingContext2D, sp: Sprite, dx: number, dy: number, dw?: number, dh?: number,
): void {
  const sw = srcW(sp), sh = srcH(sp);
  ctx.drawImage(sp.canvas, sp.sx ?? 0, sp.sy ?? 0, sw, sh, dx, dy, dw ?? sw, dh ?? sh);
}

/** Draw only the sprite's CONTENT BOX (bx,by,bw,bh) scaled into (dx,dy,dw,dh) — the icon/pip
 *  draw the kill-feed & fighter labels use (old `drawImage(sp.canvas, bx,by,bw,bh, ...)`). */
export function drawSpriteBox(
  ctx: CanvasRenderingContext2D, sp: Sprite, dx: number, dy: number, dw: number, dh: number,
): void {
  ctx.drawImage(sp.canvas, (sp.sx ?? 0) + sp.bx, (sp.sy ?? 0) + sp.by, sp.bw, sp.bh, dx, dy, dw, dh);
}
